var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstAid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49725 15.4642L3.85796 20.1534C3.93812 21.1954 4.807 22 5.85207 22H18.1479C19.193 22 20.0619 21.1954 20.142 20.1534L20.5028 15.4642C20.3386 15.4878 20.1707 15.5 20 15.5H4.00001C3.82929 15.5 3.66143 15.4878 3.49725 15.4642Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.25H13C14.5188 1.25 15.75 2.48122 15.75 4H20C21.1046 4 22 4.89543 22 6V12C22 13.1046 21.1046 14 20 14H4C2.89543 14 2 13.1046 2 12V6C2 4.89543 2.89543 4 4 4H8.25C8.25 2.48122 9.48122 1.25 11 1.25ZM11 2.75C10.3096 2.75 9.75 3.30964 9.75 4H14.25C14.25 3.30964 13.6904 2.75 13 2.75H11ZM12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V8.25H9C8.58579 8.25 8.25 8.58579 8.25 9C8.25 9.41421 8.58579 9.75 9 9.75H11.25V12C11.25 12.4142 11.5858 12.75 12 12.75C12.4142 12.75 12.75 12.4142 12.75 12V9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H12.75V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAid);
export default __webpack_public_path__ + "static/media/first-aid.5867f96f63c5a2fc1bebdd4a26fc1ff3.svg";
export { ForwardRef as ReactComponent };